export default function LibraryBoardMembership() {
    return (
<div>
<h4>Members</h4>
                  <hr/>

                  <p>
                  <b>President</b><br/>
                  Theresa Rissman
                  
                  </p>
                  <p>
                    <b>Vice-President</b><br/>
                  Maura Walsh
                  
                  </p>
                  <p>
                    <b>Treasurer</b><br/>
                  Xintong Ren-Gruszka
                  
                  </p>
                  <p>
                    <b>Secretary</b><br/>
                  Linda Mier
                  
                  
                  </p>
                  <p>
                    <b>Members</b>
                  
                  <br/>
                  Ben Strauss<br/>
                  Ann Perry<br/>
                  Pam Tevington<br/>
                  </p>
                 </div>
)
}